import React from 'react';
import '../../scss/components/_guides-card.scss'

class GuidesCard extends React.Component {
    constructor(props){
      super(props);
      this.state = { width: (typeof window !== 'undefined') ? window.innerWidth : 0 };
    }

    updateDimensions = () => {
      this.setState({ width: (typeof window !== 'undefined') ? window.innerWidth : 0 });
    };

    componentWillMount(){
      if (typeof window !== 'undefined'){
        window.addEventListener('resize', this.updateDimensions);
      }
    }
    componentWillUnmount(){
      if (typeof window !== 'undefined'){
        window.removeEventListener('resize', this.updateDimensions);
      }
    }

    render() {
    return (
    <React.Fragment>
        <div className = "contentBlock d-flex justify-content-between flex-wrap gridContainer guides-box">
            <div className="verticalGuidesColumn mb-0 innerGuidesContainer">
                <a href={this.props.readMoreLink} target="_blank" rel="noreferrer">
                    <div className="image-container">
                        <div className="icon">
                            <img src={'/resources/external-link-icon.svg'} alt="Icon external link"/>
                        </div>
                        <div className="guides-image" style={this.state.width>"800" | this.state.width<"440" ? imgUrl(this.props.urlImgDesktop,"left top") : imgUrl(this.props.urlImgMobile,"center")}></div>
                    </div>
                </a>           
                <div className="guides-text">
                    <h2>{this.props.title}</h2>
                </div> 
                <div className="guides-footer"> 
                    <p> <a href={this.props.readMoreLink} target="_blank" className="ctaStandard" rel="noreferrer"> {this.props.readMoreText} </a></p>
                </div>                         
            </div>
        </div> 
    </React.Fragment>
    )
  }
}

const imgUrl=(url,imagePosition) =>({
    backgroundImage : `url(${url})`,
    backgroundPosition: imagePosition
})
export default GuidesCard;
    
    
    
